import React from 'react';

export const HTMLField = (props) => (
  <div dangerouslySetInnerHTML={{__html:props.content}}/>
)
